import SEO from "@/components/site/SEO";
import LegalShell from "@/components/site/LegalShell";

export default function Privacy() {
  return (
    <LegalShell
      title="Privacy Policy"
      lastUpdated="January 1, 2026"
      pageTestId="privacy-page"
      seo={
        <SEO
          title="Privacy Policy"
          description="OneDial Africa Privacy Policy — how Scitygate Telecom UK Ltd collects, uses, stores and protects your personal data."
          path="/privacy-policy"
        />
      }
    >
      <p>
        OneDial Africa is a trading name of <strong>Scitygate Telecom UK Ltd</strong>,
        registered in England &amp; Wales under company number <strong data-testid="privacy-company-number">16468736</strong> (“<strong>OneDial Africa</strong>”, “we”, “us” or “our”).
        We are committed to protecting your privacy. This Privacy Policy explains how we
        collect, use, disclose, and safeguard your information when you visit
        <a href="https://www.onedialafrica.com" className="underline"> www.onedialafrica.com</a>{" "}
        or use the OneDial Africa mobile application and related services
        (collectively, the “Services”).
      </p>

      <h2>1. Information we collect</h2>
      <p>We collect information you provide directly, information collected automatically, and information from third parties.</p>
      <ul>
        <li><strong>Account data:</strong> name, email, phone number, country and date of birth.</li>
        <li><strong>Identity and verification data:</strong> documents required for KYC/AML compliance.</li>
        <li><strong>Transaction data:</strong> call detail records, top-ups, transfers, bills paid and wallet balances.</li>
        <li><strong>Device and usage data:</strong> IP address, device identifiers, app version, OS, crash logs and analytics.</li>
        <li><strong>Communications:</strong> messages you send to our support team and feedback you provide.</li>
      </ul>

      <h2>2. How we use your information</h2>
      <ul>
        <li>To provide, maintain and improve the Services.</li>
        <li>To authenticate users, prevent fraud and comply with legal obligations (including AML and sanctions checks).</li>
        <li>To process payments, transfers, top-ups and bill payments.</li>
        <li>To communicate with you about transactions, security alerts and customer support.</li>
        <li>To send marketing where you have opted in (you can opt out at any time).</li>
        <li>To analyse usage and improve product performance and reliability.</li>
      </ul>

      <h2>3. Legal bases for processing (UK/EU users)</h2>
      <p>We process personal data on the basis of: (a) performance of a contract; (b) compliance with a legal obligation; (c) our legitimate interests in operating and securing the Services; and (d) consent, where required.</p>

      <h2>4. Sharing your information</h2>
      <p>We do not sell your personal data. We may share information with:</p>
      <ul>
        <li>Mobile network operators, banks, payment processors and other partners required to deliver the Services.</li>
        <li>Identity verification, fraud-prevention and compliance providers.</li>
        <li>Cloud, analytics and customer-support providers acting as our processors.</li>
        <li>Law enforcement, regulators and other authorities where required by law.</li>
      </ul>

      <h2>5. International transfers</h2>
      <p>OneDial Africa is operated from the United Kingdom. Where we transfer personal data outside the UK or EEA, we rely on appropriate safeguards such as Standard Contractual Clauses or adequacy decisions.</p>

      <h2>6. Data retention</h2>
      <p>We retain personal data only as long as necessary to provide the Services and to comply with legal, accounting and regulatory requirements. Transaction records are typically retained for a minimum of six (6) years where required by UK law.</p>

      <h2>7. Your rights</h2>
      <p>Depending on your jurisdiction, you may have the right to access, correct, delete, restrict or object to the processing of your personal data, and to data portability. You may also withdraw consent at any time. To exercise any right, email <a href="mailto:support@onedialafrica.com" className="underline">support@onedialafrica.com</a>.</p>

      <h2>8. Security</h2>
      <p>We employ administrative, technical and physical safeguards, including encryption in transit and at rest, access controls, and continuous monitoring. No method of transmission over the internet is 100% secure; we cannot guarantee absolute security.</p>

      <h2>9. Children</h2>
      <p>OneDial Africa is not directed to children under 16. We do not knowingly collect data from children. If you believe a child has provided us data, please contact us so we can delete it.</p>

      <h2>10. Cookies and similar technologies</h2>
      <p>Our website uses cookies and similar technologies for essential functionality, analytics and (where you consent) marketing. You can control cookies via your browser settings.</p>

      <h2>11. Changes to this Policy</h2>
      <p>We may update this Privacy Policy from time to time. Material changes will be notified through the app or by email. The “Last updated” date at the top reflects the most recent revision.</p>

      <h2>12. Contact us</h2>
      <p>
        Scitygate Telecom UK Ltd<br />
        2nd Floor, Halifax House, 93–101 Bridge Street, Manchester M3 2GX, United Kingdom<br />
        Registered in England &amp; Wales · Company No. 16468736<br />
        Telephone: 0161 989 4842<br />
        Email: <a href="mailto:support@onedialafrica.com" className="underline">support@onedialafrica.com</a>
      </p>
    </LegalShell>
  );
}
